import { useEffect, useState } from 'react';

export function useLoadingElement(elementName: string) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        customElements.whenDefined(elementName).then(() => {
            setIsLoading(false);
        });
    }, [elementName]);

    return isLoading;
}
